/* tslint:disable */
import {
  CategoryRotation,
  LayoutPanel
} from '../index';

declare var Object: any;
export interface ScreenLayoutInterface {
  "id": string;
  "name"?: string;
  "width": number;
  "height": number;
  "isVertical": boolean;
  "displayRows": number;
  "displayCols": number;
  "displayWidth": number;
  "displayHeight": number;
  "categoryRotationId"?: string;
  "createdByIp"?: string;
  "lastUpdatedByIp"?: string;
  "createdAt": Date;
  "updatedAt": Date;
  categoryRotation?: CategoryRotation;
  layoutPanels?: LayoutPanel[];
}

export class ScreenLayout implements ScreenLayoutInterface {
  "id": string;
  "name": string;
  "width": number;
  "height": number;
  "isVertical": boolean;
  "displayRows": number;
  "displayCols": number;
  "displayWidth": number;
  "displayHeight": number;
  "categoryRotationId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  categoryRotation: CategoryRotation;
  layoutPanels: LayoutPanel[];
  constructor(data?: ScreenLayoutInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ScreenLayout`.
   */
  public static getModelName() {
    return "ScreenLayout";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ScreenLayout for dynamic purposes.
  **/
  public static factory(data: ScreenLayoutInterface): ScreenLayout{
    return new ScreenLayout(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ScreenLayout',
      plural: 'ScreenLayouts',
      path: 'ScreenLayouts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "width": {
          name: 'width',
          type: 'number',
          default: 1920
        },
        "height": {
          name: 'height',
          type: 'number',
          default: 1080
        },
        "isVertical": {
          name: 'isVertical',
          type: 'boolean',
          default: false
        },
        "displayRows": {
          name: 'displayRows',
          type: 'number',
          default: 1
        },
        "displayCols": {
          name: 'displayCols',
          type: 'number',
          default: 1
        },
        "displayWidth": {
          name: 'displayWidth',
          type: 'number',
          default: 1920
        },
        "displayHeight": {
          name: 'displayHeight',
          type: 'number',
          default: 1080
        },
        "categoryRotationId": {
          name: 'categoryRotationId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        categoryRotation: {
          name: 'categoryRotation',
          type: 'CategoryRotation',
          model: 'CategoryRotation',
          relationType: 'belongsTo',
                  keyFrom: 'categoryRotationId',
          keyTo: 'id'
        },
        layoutPanels: {
          name: 'layoutPanels',
          type: 'LayoutPanel[]',
          model: 'LayoutPanel',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'screenLayoutId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ScreenLayout.ts